// extracted by mini-css-extract-plugin
export var main = "f259d51e93d6a6f08bad86a3c3791324-css";